import request from '@/utils/requests';
import editMaterials from '@/store/modules/material/editMaterials';

const getters = {
  fetchStatus: (state) => state.status,
  getMaterials: (state) => state.materials,
  getFetchedMaterial: (state) => state.fetchedMaterial,
  getShouldRefetchMaterials: (state) => state.shouldRefetchMaterials,
  getCurrentPage: (state) => state.currentPage,
  getOfferingsTable: (state) => state.offeringsTable,
  getDonationsTable: (state) => state.donationsTable,
  getShouldRefetchDonations: (state) => state.shouldRefetchDonations,
  getShouldRefetchOfferings: (state) => state.shouldRefetchOfferings,
  getOfferingsAndDonations: (state) => state.offeringsAndDonations,
};
const mutations = {
  changeStatus: (state, status) => {
    state.status = status;
  },
  setMaterials: (state, materials) => {
    state.materials = materials;
  },
  setFetchedMaterial: (state, material) => {
    state.fetchedMaterial = material;
  },
  setShouldRefetchMaterials: (state, shouldRefetchMaterials) => {
    state.shouldRefetchMaterials = shouldRefetchMaterials;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  setOfferingsTable: (state, offeringsTable) => {
    state.offeringsTable = offeringsTable;
  },
  setDonationsTable: (state, donationsTable) => {
    state.donationsTable = donationsTable;
  },
  setShouldRefetchDonations: (state, shouldRefetchDonations) => {
    state.shouldRefetchDonations = shouldRefetchDonations;
  },
  setShouldRefetchOfferings: (state, shouldRefetchOfferings) => {
    state.shouldRefetchOfferings = shouldRefetchOfferings;
  },
  setOfferingsAndDonations: (state, offeringsAndDonations) => {
    state.offeringsAndDonations = offeringsAndDonations;
  },
};
const actions = {
  fetchMaterials: async ({ commit, rootGetters }, payload) => {
    commit('setShouldRefetchMaterials', false);
    try {
      commit('setMaterials', []);
      commit('changeStatus', 'loading');
      const response = await request(
        'GET',
        'api/v2/materials',
        rootGetters['auth/getToken'],
        {},
        payload.params
      );
      setTimeout(commit('setMaterials', response.data), 250);
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
  fetchMaterialById: async ({ commit, rootGetters }, material) => {
    try {
      commit('setMaterials', {});
      commit('changeStatus', 'loading');
      const response = await request(
        'GET',
        `api/v2/materials/${material.id}`,
        rootGetters['auth/getToken'],
        {},
        {}
      );
      setTimeout(commit('setFetchedMaterial', response.data), 250);
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
  fetchMaterialQuery: async ({ commit, rootGetters }, query) => {
    commit('setShouldRefetchMaterials', false);
    try {
      commit('setMaterials', {});
      commit('changeStatus', 'loading');
      const response = await request(
        'GET',
        'api/v2/materials',
        rootGetters['auth/getToken'],
        {},
        query
      );
      setTimeout(commit('setMaterials', response.data), 250);
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
  createMaterial: async ({ commit, rootGetters }, payload) => {
    try {
      commit('changeStatus', 'loading');
      const response = await request(
        'POST',
        'api/v2/materials',
        rootGetters['auth/getToken'],
        payload.offering,
        payload.query
      );
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e.message);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
  updateMaterial: async ({ commit, rootGetters }, payload) => {
    try {
      const response = await request(
        'PUT',
        `api/v2/materials/${payload.material.id}`,
        rootGetters['auth/getToken'],
        payload.material,
        payload.params
      );
      commit('setShouldRefetchMaterials', true);
      return Promise.resolve(response);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  deleteMaterial: async ({ commit, rootGetters }, payload) => {
    try {
      const response = await request(
        'DELETE',
        `api/v2/materials/${payload.id}`,
        rootGetters['auth/getToken'],
        {},
        payload.params
      );
      commit('setShouldRefetchMaterials', true);
      return Promise.resolve(response);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setShouldRefetchMaterials: ({ commit }, shouldRefetchMaterials) => {
    commit('setShouldRefetchMaterials', shouldRefetchMaterials);
  },
  fetchMaterialByIdForModal: async ({ commit, rootGetters }, material) => {
    try {
      commit('changeStatus', 'loading');
      const response = await request(
        'GET',
        `api/v2/materials/${material.id}`,
        rootGetters['auth/getToken'],
        {},
        {}
      );
      setTimeout(commit('setFetchedMaterial', response.data), 250);
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
  setCurrentPage({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  fetchDonationsTable: async ({ commit, rootGetters }, payload) => {
    try {
      const response = await request(
        'GET',
        'api/v2/materials/donations',
        rootGetters['auth/getToken'],
        {},
        payload.params
      );
      commit('setDonationsTable', response.data);
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  fetchOfferingsTable: async ({ commit, rootGetters }, payload) => {
    try {
      const response = await request(
        'GET',
        'api/v2/materials/offerings',
        rootGetters['auth/getToken'],
        {},
        payload.params
      );
      commit('setOfferingsTable', response.data);
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  setShouldRefetchDonations: ({ commit }, shouldRefetchDonations) => {
    commit('setShouldRefetchDonations', shouldRefetchDonations);
  },
  setShouldRefetchOfferings: ({ commit }, shouldRefetchOfferings) => {
    commit('setShouldRefetchOfferings', shouldRefetchOfferings);
  },
  fetchOfferingsAndDonationsForDisplay: async ({ commit, rootGetters }, payload) => {
    try {
      commit('changeStatus', 'loading');
      const response = await request(
        'GET',
        'api/v2/materials/offerings-and-donations',
        rootGetters['auth/getToken'],
        {},
        payload.params
      );
      setTimeout(commit('setMaterials', response.data), 250);
      commit('changeStatus', 'success');
      return Promise.resolve(response);
    } catch (e) {
      console.log(e);
      commit('changeStatus', 'error');
      return Promise.reject(e);
    }
  },
};
const modules = { edit: editMaterials };
const state = {
  materials: {},
  fetchedMaterial: {},
  status: '',
  shouldRefetchMaterials: false,
  currentPage: 1,
  donationsTable: {},
  shouldRefetchDonations: false,
  offeringsTable: {},
  shouldRefetchOfferings: false,
  offeringsAndDonations: {},
};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  modules,
  state,
};
